import React, {FC} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import {H3} from "@irati/ui/src/Typography"

interface Props {}

const Header: FC<Props> = () => {
  return (
    <H3 marginBottom={3}>
      <FormattedMessage id="admin.components.integration.sso.enableSSO.start.setup" />
    </H3>
  )
}

export default Header
